/**
 * Convert an object to a query string
 * @param {object} newParams The object to convert
 *
 * @returns {string} The query string
 *
 * @example
 * objectToQueryString({ a:1, b: 2 }) // returns "a=1&b=2"
 * objectToQueryString({ a:'one', b: 'two' }) // returns "a=one&b=two"
 */
const objectToQueryString = (newParams) => {
  if (
    typeof newParams !== 'object' ||
    newParams === null ||
    newParams === undefined
  ) {
    return '';
  }
  return Object.keys(newParams)
    .map((key) => `${key}=${newParams[key]}`)
    .join('&');
};

export default objectToQueryString;
